/* Kalkulator Container, der die Formulare und das Ergebnis enthält */

import { IonBackButton, IonButtons, IonCard, IonCardHeader, IonCardTitle, IonCol, IonContent, IonGrid, IonPage, IonRow, IonTitle, isPlatform } from "@ionic/react";
import { RouteComponentProps } from "react-router";
import MillerForm from "./components/MillerForm";
import { useEffect, useState } from "react";
import { CalculatorParams, CalculatorFormResult, CalculatorMillerForm, CalculatorParameterForm, CalculatorStrategyForm, CombinedCalculatorForm, CombinedTrocutFormData, CalculatorFormTrocutResult } from "./components/FormTypes";
import StrategyForm from "./components/StrategyForm";
import ParameterForm from "./components/ParameterForm";
import ResultCard from "./components/ResultCard";
import { calculateResult, calculateTrocutResult } from "./components/calculation";
import { db } from "../../data/db/db";
import { Header } from "../../components";
import TrocutParameterCard from "./components/TrocutParameterCard";
import TrocutResultCard from "./components/TrocutResultCard";
import { useTranslation } from "react-i18next";

interface CalculatorProps extends RouteComponentProps<CalculatorParams> { }


const Calculator: React.FC<CalculatorProps> = (props) => {
    const [activeForm, setActiveForm] = useState<number>(1);
    const [firstFormData, setFirstFormData] = useState<CalculatorMillerForm | undefined>()
    const [secondFormData, setSecondFormData] = useState<CalculatorStrategyForm | undefined>()
    const [thirdFormData, setThirdFormData] = useState<CalculatorParameterForm | undefined>();
    const [result, setResult] = useState<null | CalculatorFormResult>(null);
    const [trocutRes, setTrocutRes] = useState<null | CalculatorFormTrocutResult>(null)
    const params = props.match.params
    const { t } = useTranslation();

    useEffect(() => {
        let ignore = false

        if (params.ident && params.pos && params.matGroup && params.matGroup !== undefined) {
            (async () => {
                /* @ts-ignore */
                const material = await db.materials.where("gruppe").equals(params.matGroup).first()
                if (!ignore) {
                    setFirstFormData({
                        article: params.ident ? params.ident.replaceAll("-", " ") + "-" + params.pos : "",
                        diameter: "",
                        ident: params.ident ? params.ident.replaceAll("-", " ") : "",
                        pos: params.pos,
                        material: material ? material : null,
                    })
                    setActiveForm(3);
                }
            })();
        } else if (params.ident && params.pos) {
            if (!ignore) {
                setFirstFormData({
                    article: params.ident ? params.ident.replaceAll("-", " ") + "-" + params.pos : "",
                    diameter: "",
                    ident: params.ident ? params.ident.replaceAll("-", " ") : "",
                    pos: params.pos,
                    material: null,
                })
            }
        }
        if (params.strategy) {
            // TODO Trocut
            if (params.strategy === "std-bes" || params.strategy === "std-vsp" || params.strategy === "std-ko") {
                if (!ignore) {
                    setSecondFormData({ strategy: params.strategy })
                }
            }
        }
        if (params.ap) {
            if (!ignore) {
                setThirdFormData({
                    ae: undefined,
                    ap: Number(params.ap),
                    maschineSpeed: undefined,
                    spindle: "motor"
                })
            }
        }

        return (() => { ignore = true })
    }, [params])

    const millerFormCallback = (data: any) => {
        setFirstFormData(data)
        setActiveForm(activeForm + 1)
    }

    const handleEditFirstFormBtnClick = () => {
        setThirdFormData(undefined)
        setSecondFormData(undefined)
        setActiveForm(1)
    }
    const handleEditSecondFormBtnClick = () => {
        setThirdFormData(undefined)
        setActiveForm(2)
    }

    const handleEditThirdFormBtnClick = () => {
        setActiveForm(3)
    }

    const strategyFormCallback = (data: any) => {
        setSecondFormData(data);
        setActiveForm(activeForm + 1)
    }

    const parameterFormCallback = async (data: any) => {
        setThirdFormData(data)
        setActiveForm(activeForm + 1)
        const combined: CombinedCalculatorForm = { ...firstFormData, ...secondFormData, ...data }
        const res = await calculateResult(combined)
        if (res) {
            setResult(res);
        }
    }

    const parameterTrocutCallback = async () => {
        setActiveForm(activeForm + 1)
        /* @ts-ignore */
        const combined: CombinedTrocutFormData = { ...firstFormData, ...secondFormData }
        const res = await calculateTrocutResult(combined)
        setTrocutRes(res)
    }

    return (
        <IonPage>
            <Header>
                <IonButtons slot="start">
                    <IonBackButton text={isPlatform('ios') ? t("Zurück") : undefined} />
                </IonButtons>
                <IonTitle>{t("calculatorForm.Kalkulator")}</IonTitle>
            </Header>
            <IonContent>
                <IonGrid fixed={true} className="mainContent">
                    <IonRow>
                        <IonCol size="12">
                            <MillerForm
                                editBtnCallback={handleEditFirstFormBtnClick}
                                isFormShowing={activeForm === 1}
                                submitForm={millerFormCallback}
                                formData={firstFormData}
                            />
                        </IonCol>


                        {activeForm === 1 && <IonCol size="12">
                            <IonCard disabled={true}>
                                <IonCardHeader>
                                    <IonCardTitle>{t("calculatorForm.Bearbeitungs-Strategie")}</IonCardTitle>
                                </IonCardHeader>
                            </IonCard>
                        </IonCol>}


                        <StrategyForm
                            material={firstFormData?.material}
                            ident={firstFormData?.ident}
                            pos={firstFormData?.pos}
                            isFormShowing={activeForm === 2}
                            editBtnCallback={handleEditSecondFormBtnClick}
                            submitForm={strategyFormCallback}
                            formData={secondFormData}
                        />


                        {activeForm <= 2 && <IonCol size="12">
                            <IonCard disabled={true}>
                                <IonCardHeader>
                                    <IonCardTitle>{t("calculatorForm.Parameter")}</IonCardTitle>
                                </IonCardHeader>
                            </IonCard>
                        </IonCol>
                        }

                        {secondFormData && secondFormData.strategy?.startsWith("std") && <IonCol size="12">
                            <ParameterForm
                                isFormShowing={activeForm === 3}
                                submitForm={parameterFormCallback}
                                strategy={secondFormData?.strategy}
                                diameter={firstFormData?.diameter}
                                ident={firstFormData?.ident}
                                pos={firstFormData?.pos}
                                editBtnCallback={handleEditThirdFormBtnClick}
                                formData={thirdFormData}
                                material={firstFormData?.material}
                            />
                        </IonCol>}

                        {secondFormData && secondFormData.strategy === "tro" && <IonCol size="12">
                            <TrocutParameterCard
                                isResShowing={activeForm === 4}
                                isFormShowing={activeForm === 3}
                                ident={firstFormData?.ident}
                                pos={firstFormData?.pos}
                                material={firstFormData?.material?.gruppe.toLowerCase()}
                                handleSubmit={parameterTrocutCallback}
                            />
                        </IonCol>}

                        {secondFormData && secondFormData.strategy === "tro" ?
                            <TrocutResultCard isCardShowing={activeForm === 4} result={trocutRes} /> :
                            <ResultCard isCardShowing={activeForm === 4} result={result} />
                        }

                    </IonRow>
                </IonGrid>


            </IonContent>
        </IonPage >
    )
}

export default Calculator;